import type { ExactagData } from "../core/core.types";
import { exactagData } from "../core/data";
import { exactagScope } from "../core/utils";

const log = exactagScope.scope("observability.testing");

export type ExactagFlags = Record<"OptOutMode" | "testMode" | "QAMode", [boolean, string, string]>;

export const exactagFlags: ExactagFlags = {
  /*                                      */
  OptOutMode: [false, "ro", "1"],
  /*                                 */
  testMode: [false, "isTest", "true"],
  /*                                 */
  QAMode: [false, "isQA", "true"],
};

export type ExactagFlagName = keyof ExactagFlags;

export type ExactagFlag = ExactagFlags[ExactagFlagName];

export function setDataByFlag(data: ExactagData, flag: ExactagFlag, cookieVal: boolean): void {
  if (flag[0] || cookieVal) {
    log.debug("Setting flag", flag[1], "to", flag[2]);
    data[flag[1]] = flag[2];
    return;
  }

  log.debug("Removing flag", flag[1]);
  delete data[flag[1]];
}

export function getExactagFlags(data = exactagData): ExactagData {
  return Object.fromEntries(
    Object.values(exactagFlags).map(([, flagName]) => {
      return [flagName, data[flagName]];
    }),
  );
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function toggleTestMode(data = exactagData): ExactagData {
  const isTestCookie = window.o_util.cookie.get("PartnerPixelTest");
  const isQACookie = window.o_util.cookie.get("PartnerPixelPreview");
  const optOutCookie = window.o_util.cookie.get("DS");

  setDataByFlag(data, exactagFlags.testMode, isTestCookie === "PixelTest=true");
  setDataByFlag(data, exactagFlags.QAMode, isQACookie === "PixelPreview=true");
  setDataByFlag(data, exactagFlags.OptOutMode, optOutCookie === "retOptOut=1");

  return getExactagFlags(data);
}

/**
 *
 *
 *
 *
 *
 */
export function setExactagFlags(
  flags: Partial<Record<ExactagFlagName, boolean>>,
  data = exactagData,
): ExactagData {
  Object.assign(exactagFlags, flags);
  toggleTestMode(data);
  return getExactagFlags(data);
}
